import { TApiResponse } from '@/common/types/response';

import { TAnalyticsNotesMonthlyState } from './types';

export function setForeignTradeTemplateData(
  state: TAnalyticsNotesMonthlyState,
  response: TApiResponse<TAnalyticsNotesMonthlyState['foreignTradeTemplateData']>,
) {
  state.foreignTradeTemplateData = response.data;
}

export function setForeignTradeTable(
  state: TAnalyticsNotesMonthlyState,
  data: TAnalyticsNotesMonthlyState['foreignTradeTable'],
) {
  state.foreignTradeTable = data;
}

export function setExportStructureTable(
  state: TAnalyticsNotesMonthlyState,
  data: TAnalyticsNotesMonthlyState['exportStructureTable'],
) {
  state.exportStructureTable = data;
}

export function setImportStructureTable(
  state: TAnalyticsNotesMonthlyState,
  data: TAnalyticsNotesMonthlyState['importStructureTable'],
) {
  state.importStructureTable = data;
}

export function setExportProductsTable(
  state: TAnalyticsNotesMonthlyState,
  data: TAnalyticsNotesMonthlyState['exportProductsTable'],
) {
  state.exportProductsTable = data;
}

export function setImportProductsTable(
  state: TAnalyticsNotesMonthlyState,
  data: TAnalyticsNotesMonthlyState['importProductsTable'],
) {
  state.importProductsTable = data;
}
